import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_EXTERNAL_HEALTH_DASHBOARD_PARTNER_STATUS = `${URL_RETAILER_SCOPED}/partner-status`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'external-health-dashboard-partner-status'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'external-health-dashboard-partner-status': URL_EXTERNAL_HEALTH_DASHBOARD_PARTNER_STATUS,
}

export type DomainRouteName = keyof typeof routes
